import React from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'components/common';

import { toggleModal } from 'data/actions/modals';
import { pauseSequences } from 'data/actions/sequences';
import { modalsSelector, modalOptionsSelector } from 'data/selectors/modals';
import { Container } from '../deleteStep/styles';
import { ModalTitle, CloseIcon, Footer } from '../baseModal/styles';

const PauseSequencesModal = () => {
  const dispatch = useDispatch();
  const { visible } = useSelector(modalsSelector);
  const { sequenceIds, setSelectedRowKeys } = useSelector(modalOptionsSelector);

  const handleClose = () => dispatch(toggleModal('pause_sequences', false));
  const handlePause = () => {
    dispatch(pauseSequences(sequenceIds));
    if (setSelectedRowKeys) setSelectedRowKeys([]);
    handleClose();
  };

  return (
    <Modal
      visible={visible}
      title={
        <ModalTitle>
          Pause {sequenceIds.length === 1 ? 'sequence' : 'sequences'}
          <CloseIcon onClick={handleClose} className="ic_close" />
        </ModalTitle>
      }
      closable={false}
      width={500}
      footer={false}
      onCancel={handleClose}
    >
      <Container>
        <div>
          You&#39;re about to pause the
          {sequenceIds.length === 1 ? 'sequence' : 'sequences'}.
        </div>
      </Container>
      <Footer>
        <Button data-form="true" type="primary" size="large" onClick={handlePause}>
          Pause
        </Button>
        <Button size="large" type="normal" onClick={handleClose}>
          No
        </Button>
      </Footer>
    </Modal>
  );
};

export default PauseSequencesModal;
